import React from "react";

/**
 * Course setting: whether enrolled students get attachment-style downloads for media (vs inline-only).
 */
function CourseDownloadableToggle({
  checked,
  onChange,
  disabled = false,
  headingId = "course-downloadable-heading",
}) {
  return (
    <div
      className="form-group cc-descarga-contenido-toggle"
      style={{
        marginTop: 16,
        padding: 15,
        border: "1px solid #e0e0e0",
        borderRadius: 8,
        backgroundColor: "#f9f9f9",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 12,
      }}
    >
      <div style={{ flex: "1 1 280px" }}>
        <h5 id={headingId} style={{ marginTop: 0, marginBottom: 8, color: "#0d1b2a" }}>
          Descarga de materiales para alumnos
        </h5>
        <p style={{ margin: "0 0 12px", fontSize: "0.9rem", color: "#555", lineHeight: 1.45 }}>
          Por defecto, documentos, vídeo y audio solo se abren en el navegador (sin forzar descarga).
          Activa el interruptor si quieres que puedan descargarlos explícitamente.
        </p>
        <label
          style={{ display: "flex", alignItems: "center", cursor: disabled ? "not-allowed" : "pointer", gap: 15 }}
        >
          <div style={{ position: "relative", width: 50, height: 26 }}>
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => onChange(e.target.checked)}
              disabled={disabled}
              aria-labelledby={headingId}
              style={{ opacity: 0, width: 0, height: 0 }}
            />
            <span
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: checked ? "#4caf50" : "#ccc",
                transition: ".4s",
                borderRadius: 34,
              }}
            >
              <span
                style={{
                  position: "absolute",
                  height: 20,
                  width: 20,
                  left: 3,
                  bottom: 3,
                  backgroundColor: "white",
                  transition: ".4s",
                  borderRadius: "50%",
                  transform: checked ? "translateX(24px)" : "translateX(0)",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                }}
              />
            </span>
          </div>
          <div>
            <span style={{ fontWeight: "bold", fontSize: "1.05rem", color: checked ? "#2e7d32" : "#616161" }}>
              {checked ? "Descarga habilitada" : "Solo visualización (predeterminado)"}
            </span>
          </div>
        </label>
      </div>
    </div>
  );
}

export default CourseDownloadableToggle;
